
const ko = require('knockout');

require('rgs-bootstrap');

const { bsTooltipPopoverBindingFactory } = require('./bsTooltip.js');


// Bootstrap popover
ko.bindingHandlers.bsPopover = bsTooltipPopoverBindingFactory({
	bsPluginName: 'popover',
});
